/*
  Ivy Pillow — productopbouw: hotspots op de foto en de lagenlijst zijn
  gekoppeld. Eén laag staat open; het accentlijntje eronder is de timer die
  volloopt, waarna de volgende laag opent. De timer is een echte
  animatie-speler (Web Animations API): pauzeren en hervatten gebeurt
  framenauwkeurig, zonder per-frame rekenwerk in JavaScript.
*/
(() => {
  const DUUR_MS = 6000;

  class IvyOpbouw extends HTMLElement {
    connectedCallback() {
      this.spots = Array.from(this.querySelectorAll('[data-opbouw-spot]'));
      this.items = Array.from(this.querySelectorAll('[data-opbouw-item]'));
      this.rustig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.animatie = null;
      this.inBeeld = true;

      if (this.dataset.ivyInit !== 'true') {
        this.dataset.ivyInit = 'true';

        this.spots.forEach((spot) => {
          spot.addEventListener('click', () => this.open(parseInt(spot.dataset.opbouwSpot, 10)));
        });
        this.querySelectorAll('[data-opbouw-knop]').forEach((knop) => {
          knop.addEventListener('click', () => this.open(parseInt(knop.dataset.opbouwKnop, 10)));
        });

        // Alleen pauzeren bij een echte muis: op touch blijft mouseenter
        // anders hangen na één tik.
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          this.addEventListener('mouseenter', () => this.pauzeer());
          this.addEventListener('mouseleave', () => this.hervat());
        }

        // Timer loopt alleen zolang de sectie in beeld is
        if ('IntersectionObserver' in window) {
          this.inBeeld = false;
          new IntersectionObserver((entries) => {
            this.inBeeld = entries[0].isIntersecting;
            if (this.inBeeld) this.hervat();
            else this.pauzeer();
          }).observe(this);
        }
      }

      this.open(0);
    }

    disconnectedCallback() {
      if (this.animatie) this.animatie.cancel();
    }

    pauzeer() {
      if (this.animatie && this.animatie.playState === 'running') this.animatie.pause();
    }

    hervat() {
      if (!this.inBeeld) return;
      if (this.animatie && this.animatie.playState === 'paused') this.animatie.play();
    }

    open(index) {
      this.huidig = index;

      this.items.forEach((item, i) => {
        const actief = i === index;
        item.classList.toggle('ivy-opbouw__item--open', actief);
        const knop = item.querySelector('[data-opbouw-knop]');
        if (knop) knop.setAttribute('aria-expanded', actief ? 'true' : 'false');
      });
      this.spots.forEach((spot, i) => {
        spot.classList.toggle('ivy-opbouw__spot--actief', i === index);
      });

      if (this.animatie) {
        this.animatie.cancel();
        this.animatie = null;
      }

      const balk = this.items[index] && this.items[index].querySelector('.ivy-opbouw__accent-vul');
      if (!balk) return;

      if (this.rustig || this.items.length < 2 || typeof balk.animate !== 'function') {
        balk.style.setProperty('--opbouw-voortgang', '1');
        return;
      }

      this.animatie = balk.animate(
        [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
        { duration: DUUR_MS, easing: 'linear', fill: 'forwards' }
      );
      this.animatie.onfinish = () => this.open((this.huidig + 1) % this.items.length);
      if (!this.inBeeld) this.animatie.pause();
    }
  }

  if (!customElements.get('ivy-opbouw')) {
    customElements.define('ivy-opbouw', IvyOpbouw);
  }
})();
